'use strict';

/**
 * View/Layout for create/edit object
 *
 * @category   View
 * @module     edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoLayoutView = require('base/Colido.LayoutView');
var FileUploadView = require('modules/global/views/components/file-upload');

var template = require('../../templates/components/upload.hbs');

var UploadComponent = ColidoLayoutView.extend({
    template: template,

    ui: {
        container: '.import-component',
        selectedFile: '#selected-file',
        buttonStartOver: '[data-action="start-over"]',
    },

    events: {
        'click @ui.buttonStartOver': 'onStartOver',
    },

    regions: {
        'fileSelectRegion': '#subregion-file-select',
    },

    viewData: {
        step: function() {
            return this.getOption('step') || 1;
        },
    },

    childEvents: {
        'upload:state:selected': 'onUploadFileSelected',
        'upload:state:finished': 'onUploadFinished',
        'upload:state:error': 'onUploadError',
    },

    onRender: function() {
        var fileSelectView = new FileUploadView({
            uploadHandler: _.result(this.model, 'url'),
        });

        this.fileSelectRegion.show(fileSelectView);
    },

    /**
     * Is triggered from layout view, on proceed/next click
     */
    onParentProceed: function() {
        this.fileSelectRegion.currentView.triggerMethod('action:upload:file');
    },

    /**
     * Is triggered, when an file has been selected by the file upload component
     * @param {BaseModule.FileUploadView}   childView The file upload view
     * @param {object}                      event     The jquery change event
     */
    onUploadFileSelected: function(childView, event) {
        var file = _.first(event.currentTarget.files);
        this.ui.selectedFile.html(file.name);
        this.triggerMethod('component:upload:file:selected', event);
    },

    /**
     * Notify parent view, that upload is finished
     * @param {BaseModule.FileUploadView}   childView The file upload view
     * @param {XMLHttpRequestProgressEvent} event     The progress event
     */
    onUploadFinished: function(childView, event) {
        this.ui.container.attr('data-state', 'finished');
        this.triggerMethod('component:upload:state:finished', event);
    },

    /**
     * Notify parent view, that upload has an error
     * @param {BaseModule.FileUploadView}   childView The file upload view
     * @param {XMLHttpRequestProgressEvent} event     The upload error event
     */
    onUploadError: function(childView, event) {
        this.triggerMethod('component:upload:state:error', event);
    },

    /**
     * Is triggered, when startover is clicked
     * @param {object} event The klick event
     */
    onStartOver: function(event) {
        this.ui.container.attr('data-state', 'pending');
        this.model.set('state', 'upload');
    },
});

module.exports = UploadComponent;